import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { setClassNames } from '@ddc/classnames-js';
import { useRequestData, useLabels } from 'wsm-common-data';
import { useLocalStorage } from '../hooks/useLocalStorage';
import {
	UNSUBSCRIBE_SINGLE,
	UNSUBSCRIBE_ALL,
	MY_CARS_KEY
} from '../global-constants';

const MainTitle = () => {
	const { deviceType } = useRequestData();
	const { vehicles: storedVehicles = [] } = useLocalStorage(MY_CARS_KEY);
	const {
		moreRequestData: {
			parameterMap: { eventType = '', vehicleId = '' }
		}
	} = useSelector((state) => state);
	const labels = useLabels();

	// Calculate the number of vehicles being tracked, excluding the current vehicle
	const trackedVehiclesCount = useMemo(
		() =>
			storedVehicles.filter(
				(vehicle) => vehicle.tracked && vehicle.uuid !== vehicleId
			).length,
		[storedVehicles, vehicleId]
	);

	const isDesktop = deviceType === 'DESKTOP';

	const { title, description } = useMemo(() => {
		const otherVehiclesComplement = (
			<>
				{`${labels.get('MYCARS_ALSO_TRACKING')} `}
				<span className="text-primary">
					{trackedVehiclesCount}
				</span>{' '}
				{`${
					trackedVehiclesCount === 1
						? labels.get('MORE_VEHICLES')
						: labels.get('OTHER_VEHICLES')
				}.`}
			</>
		);

		if (eventType === UNSUBSCRIBE_ALL) {
			return {
				title: labels.get('MYCARS_STOP_TRACKING_ALL_PRICE'),
				description: labels.get('MYCARS_NO_LONGER_EMAIL_YOU_ALL')
			};
		}
		if (eventType === UNSUBSCRIBE_SINGLE) {
			return {
				title: labels.get('MYCARS_STOP_TRACKING_PRICE'),
				description: labels.get('MYCARS_NO_LONGER_EMAIL_YOU')
			};
		}
		return {
			title: labels.get('MYCARS_ALERT_SIGN_UP'),
			description: (
				<>
					{`${labels.get('MYCARS_WE_EMAIL_YOU')} `}
					{trackedVehiclesCount ? otherVehiclesComplement : ''}
				</>
			)
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [eventType, trackedVehiclesCount]);

	const descriptionClasses = [
		'text-center ddc-font-size-base text-black mt-0 mt-4 w-75',
		isDesktop ? 'w-75' : 'w-100 mb-0'
	];

	return (
		<div className="main-title d-flex flex-column align-items-center text-center divider-centered-border-bottom divider-primary divider-2">
			<h1 className="font-weight-light text-black ddc-font-size-xxlarge m-0">
				{title}
			</h1>
			<h2 className={setClassNames(descriptionClasses)}>{description}</h2>
		</div>
	);
};

export default MainTitle;
